import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, Input, OnChanges, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIcon } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { Store } from '@ngrx/store';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { getSelectedBusiness } from 'libs/workroom/data/stores/business/business.selectors';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { take } from 'rxjs';

import { UserBusiness } from '@offconon/core-api';
import { setLeftColumnVisible } from '@offconon/shared/features/layout';
import { ThemeService } from '@offconon/shared/ui/theme-switch';
import { DesignPanelsHelperService } from '@offconon/shared/utils/services/design-panels-helper';
import { EnvironmentService } from '@offconon/shared/utils/services/environment';
import { RbacHelperService } from '@offconon/shared/utils/services/rbac-helper';
import { isRbacListContainsRbacRule } from '@offconon/workroom/features/rbac-module';

@Component({
  selector: 'offconon-erp-module-menu',
  imports: [CommonModule, RouterModule, MatIcon, TranslateModule, ButtonModule, TooltipModule],
  templateUrl: './erp-module-menu.component.html',
  styles: ``,
})
export class ErpModuleMenuComponent implements OnInit, OnChanges {
  private environmentService = inject(EnvironmentService);
  @Input() activepage: any;
  @Input() app_enum: any;
  @Input() rbac_enum_check = false;
  @Input() footer = true;
  @Input() cube_common_data: any;

  moduleMenuItems: any;
  mobileView = toSignal(inject(ThemeService).mobileView);

  module_active: any;

  moduleEnumList: any;
  selectedBusiness: UserBusiness;

  rule_type: any; //for rbac menu

  private router = inject(Router);
  private translateService = inject(TranslateService);
  private store$ = inject(Store);
  private rbacHelperService = inject(RbacHelperService);
  private designPanelsHelperService = inject(DesignPanelsHelperService);
  private destroyRef = inject(DestroyRef);
  private store = inject(Store);

  ngOnChanges(): void {
    if (this.app_enum) this.createHeaderMenu(this.activepage, this.app_enum, this.cube_common_data);
  }

  ngOnInit() {
    if (this.rbac_enum_check) {
      this.designPanelsHelperService.rbacData$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: (postData: any) => {
          if (postData) {
            this.rule_type = postData?.rule_type_link;

            if (this.rule_type) {
              this.erpRBACMenu(this.activepage);
            }
          }
        },
      });
    }

    this.store$.select(getSelectedBusiness).subscribe((res) => {
      this.selectedBusiness = res as UserBusiness;

      this.createHeaderMenu(this.activepage, this.app_enum, this.cube_common_data);
    });
  }

  back() {
    window.history.back();
  }

  commandSelector(command: any) {
    switch (command) {
      case 'command': {
        //statements redirect to selected command;
        break;
      }
      case 'business_networking': {
        this.businessNetworking();
        break;
      }
    }
  }

  openSubPage(url: any) {
    this.router.navigate([url]);
  }

  businessNetworking() {
    window.open(`${this.environmentService.environment.coreUrl}/bizconnect`, '_blank');
  }

  onCoreSubPage(url: any) {
    window.open(`${this.environmentService.environment.coreUrl}` + url, '_blank');
  }

  openSelector(url: any, side = 'erp') {
    if (side === 'erp') {
      this.openSubPage(url);
    } else {
      this.onCoreSubPage(url);
    }
  }

  createHeaderMenu(activepage: any, app_enum: any, cube_common_data: any) {
    switch (app_enum) {
      case 'business_manager': {
        this.businessManagerMenu(activepage);
        break;
      }
      case 'sales_team': {
        this.salesTeamMenu(activepage);
        break;
      }
      case 'business_passport': {
        this.businessPassportMenu(activepage);
        break;
      }
      case 'task_manager': {
        this.businessTaskManagerMenu(activepage);
        break;
      }

      case 'financial_management': {
        this.erpFinancialManagementMenu(activepage);
        break;
      }

      case 'crm': {
        this.erpCrmMenu(activepage);
        break;
      }

      case 'rbac': {
        this.erpRBACMenu(activepage);
        break;
      }
      case 'email_manager': {
        this.erpEmailManagerMenu(activepage);
        break;
      }

      case 'popularity_center': {
        this.erpPopularityCenterMenu(activepage);
        break;
      }

      case 'hrms': {
        this.erpHRMSMenu(activepage);
        break;
      }
      case 'marketing_tools': {
        this.erpMarketingToolsMenu(activepage);
        break;
      }
      case 'company_navigator': {
        this.erpCompanyNavigatorMenu(activepage);
        break;
      }
      case 'calendar': {
        this.employeeCalendarMenu(activepage);
        break;
      }

      case 'auction_manager': {
        this.auctionManagerMenu(activepage);
        break;
      }
      case 'location_manager': {
        this.locationManagerMenu(activepage);
        break;
      }
      case 'custom_fields': {
        this.customFieldsMenu(activepage);
        break;
      }
      case 'form_builder': {
        this.formBuilderMenu(activepage);
        break;
      }
      case 'target_market': {
        this.erpTargetMarketMenu(activepage);
        break;
      }

      case 'social_connections': {
        this.erpSocialConnectionMenu(activepage);
        break;
      }

      case 'procurements': {
        this.procurementsMenu(activepage);
        break;
      }
      case 'partner_office': {
        this.partnerOfficeMenu(activepage);
        break;
      }

      case 'contacts': {
        this.erpContactsMenu(activepage);
        break;
      }
      case 'bi': {
        this.erpbiMenu(activepage);
        break;
      }

      case 'insurance_manager': {
        this.insuranceManagerMenu(activepage);
        break;
      }

      case 'transportation_manager': {
        this.transportationManagerMenu(activepage);
        break;
      }

      case 'reputation_manager': {
        this.reputationMenu(activepage);
        break;
      }

      case 'tax_manager': {
        this.taxMenu(activepage);
        break;
      }

      case 'website_manager': {
        this.websiteManagerMenu(activepage);
        break;
      }

      case 'professional_services': {
        this.erpProfessionalServicesMenu(activepage);
        break;
      }

      //cube business models
      case 'retail':
      case 'consultation':
      case 'renting':
      case 'digital_product':
      case 'digital_media':
      case 'digital_magazine':
      case 'digital_podcast':
      case 'booking':
      case 'restaurant':
      case 'headhunter':
      case 'knowledge_academy': {
        this.cubeCommonMenu(activepage, cube_common_data);
        break;
      }
    }
  }

  cubeCommonMenu(activepage: any, cube_common_data: any) {
    this.moduleMenuItems = [
      {
        label: this.translateService.instant(cube_common_data?.app_brand_name),
        visible: this.isMenuAccess('smart_cube_manage') || this.isMenuAccess('smart_cube_settings'),
        items: [
          {
            link: cube_common_data?.app_url,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.dashboard_module?.dashboard_module,
            icon: 'dashboard',
            label: _('Dashboard'),
          },
          {
            link: cube_common_data?.app_url + '/settings',
            visible:
              this.isMenuAccess('smart_cube_settings') &&
              cube_common_data?.settings_module?.settings_module,
            icon: 'tune',
            label: _('Business model settings'),
          },
        ],
      },
      {
        label: cube_common_data?.sales_management?.module_name,
        visible:
          this.isMenuAccess('smart_cube_manage') && cube_common_data?.sales_management?.sales_module
            ? cube_common_data?.sales_management?.sales_module
            : false,
        items: [
          //product ad
          {
            link: cube_common_data?.inventory_management?.ads_management?.list_link,
            icon: cube_common_data?.inventory_management?.ads_management?.icon,
            label: cube_common_data?.inventory_management?.ads_management?.ads_list_name,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.inventory_management?.ads_management?.ads_module
                ? cube_common_data?.inventory_management?.ads_management?.ads_module
                : false,
          },

          //service ad
          {
            link: cube_common_data?.service_management?.ads_management?.list_link,
            icon: cube_common_data?.service_management?.ads_management?.icon,
            label: cube_common_data?.service_management?.ads_management?.ads_list_name,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.service_management?.ads_management?.ads_module
                ? cube_common_data?.service_management?.ads_management?.ads_module
                : false,
          },

          //asset ad
          {
            link: cube_common_data?.asset_management?.ads_management?.list_link,
            icon: cube_common_data?.asset_management?.ads_management?.icon,
            label: cube_common_data?.asset_management?.ads_management?.ads_list_name,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.asset_management?.ads_management?.ads_module
                ? cube_common_data?.asset_management?.ads_management?.ads_module
                : false,
          },

          //digital product ad
          {
            link: cube_common_data?.digital_file_management?.ads_management?.list_link,
            icon: cube_common_data?.digital_file_management?.ads_management?.icon,
            label: cube_common_data?.digital_file_management?.ads_management?.ads_list_name,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.digital_file_management?.ads_management?.ads_module
                ? cube_common_data?.digital_file_management?.ads_management?.ads_module
                : false,
          },

          //food product ad
          {
            link: cube_common_data?.food_management?.ads_management?.list_link,
            icon: cube_common_data?.food_management?.ads_management?.icon,
            label: cube_common_data?.food_management?.ads_management?.ads_list_name,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.food_management?.ads_management?.ads_module
                ? cube_common_data?.food_management?.ads_management?.ads_module
                : false,
          },

          //job ad
          {
            link: cube_common_data?.recruiting_management?.ads_management?.list_link,
            icon: cube_common_data?.recruiting_management?.ads_management?.icon,
            label: cube_common_data?.recruiting_management?.ads_management?.ads_list_name,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.recruiting_management?.ads_management?.ads_module
                ? cube_common_data?.recruiting_management?.ads_management?.ads_module
                : false,
          },

          //media ad
          {
            link: cube_common_data?.digital_media_management?.ads_management?.list_link,
            icon: cube_common_data?.digital_media_management?.ads_management?.icon,
            label: cube_common_data?.digital_media_management?.ads_management?.ads_list_name,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.digital_media_management?.ads_management?.ads_module
                ? cube_common_data?.digital_media_management?.ads_management?.ads_module
                : false,
          },
        ],
      },

      //product sell
      {
        label: cube_common_data?.inventory_management?.name,
        visible: cube_common_data?.inventory_management?.inventory_management_module
          ? cube_common_data?.inventory_management?.inventory_management_module
          : false,
        items: [
          {
            link: cube_common_data?.inventory_management?.list_link,
            icon: cube_common_data?.inventory_management?.list_icon,
            label: cube_common_data?.inventory_management?.list,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.inventory_management?.inventory_management_module
                ? cube_common_data?.inventory_management?.inventory_management_module
                : false,
          },
          {
            link: cube_common_data?.inventory_management?.create_link,
            icon: cube_common_data?.inventory_management?.add_icon,
            label: cube_common_data?.inventory_management?.add,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.inventory_management?.inventory_management_module
                ? cube_common_data?.inventory_management?.inventory_management_module
                : false,
          },
          {
            link: cube_common_data?.inventory_management?.stock_add_link,
            icon: cube_common_data?.inventory_management?.stock_icon,
            label: cube_common_data?.inventory_management?.stock,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.inventory_management?.stock_module
                ? cube_common_data?.inventory_management?.stock_module
                : false,
          },
          {
            link: cube_common_data?.inventory_management?.wirte_off_link,
            icon: cube_common_data?.inventory_management?.wirte_off_icon,
            label: cube_common_data?.inventory_management?.wirte_off,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.inventory_management?.wirte_off_module
                ? cube_common_data?.inventory_management?.wirte_off_module
                : false,
          },
          {
            link: cube_common_data?.inventory_management?.stock_transfer_link,
            icon: cube_common_data?.inventory_management?.stock_transfer_icon,
            label: cube_common_data?.inventory_management?.stock_transfer,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.inventory_management?.stock_transfer_module
                ? cube_common_data?.inventory_management?.stock_transfer_module
                : false,
          },

          {
            link: cube_common_data?.inventory_management?.catalog_management?.catalog_list_link,
            icon: cube_common_data?.inventory_management?.catalog_management?.icon,
            label: cube_common_data?.inventory_management?.catalog_management?.catalog_name,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.inventory_management?.catalog_management?.catalog_module
                ? cube_common_data?.inventory_management?.catalog_management?.catalog_module
                : false,
          },
        ],
      },

      //asset - renting
      {
        label: cube_common_data?.asset_management?.name,
        visible:
          this.isMenuAccess('smart_cube_manage') &&
          cube_common_data?.asset_management?.asset_management_module
            ? cube_common_data?.asset_management?.asset_management_module
            : false,
        items: [
          {
            link: cube_common_data?.asset_management?.list_link,
            icon: cube_common_data?.asset_management?.list_icon,
            label: cube_common_data?.asset_management?.list,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.asset_management?.asset_management_module
                ? cube_common_data?.asset_management?.asset_management_module
                : false,
          },
          {
            link: cube_common_data?.asset_management?.create_link,
            icon: cube_common_data?.asset_management?.add_icon,
            label: cube_common_data?.asset_management?.add,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.asset_management?.asset_management_module
                ? cube_common_data?.asset_management?.asset_management_module
                : false,
          },

          {
            link: cube_common_data?.asset_management?.wirte_off_link,
            icon: cube_common_data?.asset_management?.wirte_off_icon,
            label: cube_common_data?.asset_management?.wirte_off,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.asset_management?.wirte_off_module
                ? cube_common_data?.asset_management?.wirte_off_module
                : false,
          },
          {
            link: cube_common_data?.asset_management?.stock_transfer_link,
            icon: cube_common_data?.asset_management?.stock_transfer_icon,
            label: cube_common_data?.asset_management?.stock_transfer,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.asset_management?.stock_transfer_module
                ? cube_common_data?.asset_management?.stock_transfer_module
                : false,
          },

          {
            link: cube_common_data?.asset_management?.calendar_module?.calendar_list_link,
            icon: cube_common_data?.asset_management?.calendar_module?.icon,
            label: cube_common_data?.asset_management?.calendar_module?.name,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.asset_management?.calendar_module?.status
                ? cube_common_data?.asset_management?.calendar_module?.status
                : false,
          },

          {
            link: cube_common_data?.asset_management?.catalog_management?.catalog_list_link,
            icon: cube_common_data?.asset_management?.catalog_management?.icon,
            label: cube_common_data?.asset_management?.catalog_management?.catalog_name,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.asset_management?.catalog_management?.catalog_module
                ? cube_common_data?.asset_management?.catalog_management?.catalog_module
                : false,
          },
        ],
      },

      //food sell
      {
        label: cube_common_data?.food_management?.name,
        visible:
          this.isMenuAccess('smart_cube_manage') &&
          cube_common_data?.food_management?.food_management_module
            ? cube_common_data?.food_management?.food_management_module
            : false,
        items: [
          {
            link: cube_common_data?.food_management?.list_link,
            icon: cube_common_data?.food_management?.list_icon,
            label: cube_common_data?.food_management?.list,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.food_management?.food_management_module
                ? cube_common_data?.food_management?.food_management_module
                : false,
          },
          {
            link: cube_common_data?.food_management?.create_link,
            icon: cube_common_data?.food_management?.add_icon,
            label: cube_common_data?.food_management?.add,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.food_management?.food_management_module
                ? cube_common_data?.food_management?.food_management_module
                : false,
          },
          {
            link: cube_common_data?.food_management?.stock_add_link,
            icon: cube_common_data?.food_management?.stock_icon,
            label: cube_common_data?.food_management?.stock,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.food_management?.stock_module
                ? cube_common_data?.food_management?.stock_module
                : false,
          },
          {
            link: cube_common_data?.food_management?.wirte_off_link,
            icon: cube_common_data?.food_management?.wirte_off_icon,
            label: cube_common_data?.food_management?.wirte_off,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.food_management?.wirte_off_module
                ? cube_common_data?.food_management?.wirte_off_module
                : false,
          },
          {
            link: cube_common_data?.food_management?.stock_transfer_link,
            icon: cube_common_data?.food_management?.stock_transfer_icon,
            label: cube_common_data?.food_management?.stock_transfer,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.food_management?.stock_transfer_module
                ? cube_common_data?.food_management?.stock_transfer_module
                : false,
          },

          {
            link: cube_common_data?.food_management?.catalog_management?.catalog_list_link,
            icon: cube_common_data?.food_management?.catalog_management?.icon,
            label: cube_common_data?.food_management?.catalog_management?.catalog_name,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.food_management?.catalog_management?.catalog_module
                ? cube_common_data?.food_management?.catalog_management?.catalog_module
                : false,
          },
        ],
      },

      //service
      {
        label: cube_common_data?.service_management?.name,
        visible:
          this.isMenuAccess('smart_cube_manage') &&
          cube_common_data?.service_management?.service_management_module
            ? cube_common_data?.service_management?.service_management_module
            : false,
        items: [
          {
            link: cube_common_data?.service_management?.list_link,
            icon: cube_common_data?.service_management?.list_icon,
            label: cube_common_data?.service_management?.list,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.service_management?.service_management_module
                ? cube_common_data?.service_management?.service_management_module
                : false,
          },
          {
            link: cube_common_data?.service_management?.create_link,
            icon: cube_common_data?.service_management?.add_icon,
            label: cube_common_data?.service_management?.add,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.service_management?.service_management_module
                ? cube_common_data?.service_management?.service_management_module
                : false,
          },
          {
            link: cube_common_data?.service_management?.calendar_module?.calendar_list_link,
            icon: cube_common_data?.service_management?.calendar_module?.icon,
            label: cube_common_data?.service_management?.calendar_module?.name,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.service_management?.calendar_module?.status
                ? cube_common_data?.service_management?.calendar_module?.status
                : false,
          },
          {
            link: cube_common_data?.service_management?.catalog_management?.catalog_list_link,
            icon: cube_common_data?.service_management?.catalog_management?.icon,
            label: cube_common_data?.service_management?.catalog_management?.catalog_name,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.service_management?.catalog_management?.catalog_module
                ? cube_common_data?.service_management?.catalog_management?.catalog_module
                : false,
          },
        ],
      },

      //digital product
      {
        label: cube_common_data?.digital_file_management?.name,
        visible:
          this.isMenuAccess('smart_cube_manage') &&
          cube_common_data?.digital_file_management?.digital_file_management_module
            ? cube_common_data?.digital_file_management?.digital_file_management_module
            : false,
        items: [
          {
            link: cube_common_data?.digital_file_management?.list_link,
            icon: cube_common_data?.digital_file_management?.list_icon,
            label: cube_common_data?.digital_file_management?.list,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.digital_file_management?.digital_file_management_module
                ? cube_common_data?.digital_file_management?.digital_file_management_module
                : false,
          },
          {
            link: cube_common_data?.digital_file_management?.create_link,
            icon: cube_common_data?.digital_file_management?.add_icon,
            label: cube_common_data?.digital_file_management?.add,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.digital_file_management?.digital_file_management_module
                ? cube_common_data?.digital_file_management?.digital_file_management_module
                : false,
          },
        ],
      },

      //digital_media
      {
        label: cube_common_data?.digital_media_management?.name,
        visible:
          this.isMenuAccess('smart_cube_manage') &&
          cube_common_data?.digital_media_management?.digital_media_management_module
            ? cube_common_data?.digital_media_management?.digital_media_management_module
            : false,
        items: [
          {
            link: cube_common_data?.digital_media_management?.list_link,
            icon: cube_common_data?.digital_media_management?.list_icon,
            label: cube_common_data?.digital_media_management?.list,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.digital_media_management?.digital_media_management_module
                ? cube_common_data?.digital_media_management?.digital_media_management_module
                : false,
          },
          {
            link: cube_common_data?.digital_media_management?.create_link,
            icon: cube_common_data?.digital_media_management?.add_icon,
            label: cube_common_data?.digital_media_management?.add,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.digital_media_management?.digital_media_management_module
                ? cube_common_data?.digital_media_management?.digital_media_management_module
                : false,
          },
        ],
      },

      //recruiting_management
      {
        label: cube_common_data?.recruiting_management?.name,
        visible:
          this.isMenuAccess('smart_cube_manage') &&
          cube_common_data?.recruiting_management?.recruiting_management_module
            ? cube_common_data?.recruiting_management?.recruiting_management_module
            : false,
        items: [
          {
            link: cube_common_data?.recruiting_management?.list_link,
            icon: cube_common_data?.recruiting_management?.list_icon,
            label: cube_common_data?.recruiting_management?.list,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.recruiting_management?.recruiting_management_module
                ? cube_common_data?.recruiting_management?.recruiting_management_module
                : false,
          },
          {
            link: cube_common_data?.recruiting_management?.create_link,
            icon: cube_common_data?.recruiting_management?.add_icon,
            label: cube_common_data?.recruiting_management?.add,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.recruiting_management?.recruiting_management_module
                ? cube_common_data?.recruiting_management?.recruiting_management_module
                : false,
          },
        ],
      },

      {
        label: this.translateService.instant('Tools'),
        items: [
          {
            link: '/transportation-management/shipping-rules',
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.settings_module?.shipping?.module_active
                ? cube_common_data?.settings_module?.shipping?.module_active
                : false,
            icon: 'flight_takeoff',
            label: _('Shipping rules'),
          },
          {
            link: cube_common_data?.settings_module?.shipping?.list_link,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.settings_module?.shipping?.module_active
                ? cube_common_data?.settings_module?.shipping?.module_active
                : false,
            icon: cube_common_data?.settings_module?.shipping?.icon,
            label: cube_common_data?.settings_module?.shipping?.name
              ? cube_common_data?.settings_module?.shipping?.name
              : '-',
          },

          {
            link: '/insurance-management/insurance-rules',
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.settings_module?.insurance?.module_active
                ? cube_common_data?.settings_module?.insurance?.module_active
                : false,
            icon: 'running_with_errors',
            label: _('Insurance rules'),
          },

          {
            link: cube_common_data?.settings_module?.insurance?.list_link,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.settings_module?.insurance?.module_active
                ? cube_common_data?.settings_module?.insurance?.module_active
                : false,
            icon: cube_common_data?.settings_module?.insurance?.icon,
            label: cube_common_data?.settings_module?.insurance?.name
              ? cube_common_data?.settings_module?.insurance?.name
              : '-',
          },

          {
            link: cube_common_data?.settings_module?.refund?.list_link,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.settings_module?.refund?.module_active
                ? cube_common_data?.settings_module?.refund?.module_active
                : false,
            icon: cube_common_data?.settings_module?.refund?.icon,
            label: cube_common_data?.settings_module?.refund?.name
              ? cube_common_data?.settings_module?.refund?.name
              : '-',
          },

          {
            link: cube_common_data?.settings_module?.disclaimer?.list_link,
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.settings_module?.disclaimer?.module_active
                ? cube_common_data?.settings_module?.disclaimer?.module_active
                : false,
            icon: cube_common_data?.settings_module?.disclaimer?.icon,
            label: cube_common_data?.settings_module?.disclaimer?.name
              ? cube_common_data?.settings_module?.disclaimer?.name
              : '-',
          },

          {
            link: '/auction-management/bid-increments',
            visible:
              this.isMenuAccess('smart_cube_manage') &&
              cube_common_data?.settings_module?.auction_bid
                ? cube_common_data?.settings_module?.auction_bid
                : false,
            icon: 'content_copy',
            label: _('Bid increments'),
          },
          {
            link: '/custom-fields',
            icon: 'assignment',
            label: _('Custom fields'),
            visible: this.isMenuAccess('smart_cube_manage') && this.isMenuAccess('helper_settings'),
          },
        ],
      },

      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  websiteManagerMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Website / Application manager'),
        items: [
          {
            link: '/website-application-manager/websites',
            icon: 'app_shortcut',
            label: _('Websites'),
          },
          {
            link: '/website-application-manager/website-addresses',
            icon: 'bubble_chart',
            label: 'Website addresses',
          },
        ],
      },

      {
        label: _('Templates'),
        items: [
          {
            link: '/website-application-manager/website-templates',
            icon: 'call_to_action',
            label: _('Website templates'),
          },
          {
            link: '/website-application-manager/page-templates',
            icon: 'description',
            label: _('Page templates'),
          },
          {
            link: '/website-application-manager/component-templates',
            icon: 'category',
            label: _('Component templates'),
          },
        ],
      },

      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  taxMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Tax management'),
        items: [
          {
            link: '/tax-management/tax-rules',
            icon: 'design_services',
            label: _('Tax rules'),
          },
        ],
      },

      {
        label: _('Databases'),
        items: [
          {
            link: '/tax-management/pre-made-tax-rules',
            icon: 'list_alt',
            label: _('Database of tax rules'),
          },
        ],
      },

      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  reputationMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Reputation manager'),
        items: [
          {
            link: '/reputation-manager',
            icon: 'star',
            label: _('Ratings from customers'),
          },
          {
            link: '/reputation-manager/given-ratings',
            icon: 'star_border',
            label: _('Given ratings'),
          },
          {
            link: '/reputation-manager/pending-ratings',
            icon: 'star_half',
            label: _('Pending ratings'),
          },
        ],
      },

      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  erpbiMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Business Intelligence reports (BI)'),
        items: [
          {
            link: '/bi',
            icon: 'dashboard',
            label: _('Dashboard'),
          },
        ],
      },

      {
        label: _('Sales and Marketing'),
        items: [
          {
            link: '/bi/sales-marketing',
            icon: 'dashboard',
            label: _('Dashboard'),
          },
          {
            link: '/bi/sales-marketing/ads',
            icon: 'dashboard',
            label: _('Ads'),
          },
        ],
      },

      {
        label: _('Strategy and Planning'),
        items: [
          {
            link: '/bi/strategy-planning',
            icon: 'dashboard',
            label: _('Dashboard'),
          },
        ],
      },

      {
        label: _('Clients and Services'),
        items: [
          {
            link: '/bi/clients-services',
            icon: 'dashboard',
            label: _('Dashboard'),
          },
        ],
      },

      {
        label: _('People and Operations'),
        items: [
          {
            link: '/bi/people-operations',
            icon: 'dashboard',
            label: _('Dashboard'),
          },
        ],
      },

      {
        label: _('Cashflow and Finance'),
        items: [
          {
            link: '/bi/cashflow-finance',
            icon: 'dashboard',
            label: _('Dashboard'),
          },
        ],
      },

      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  erpContactsMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Application'),
        items: [
          {
            link: '/contacts',
            icon: 'contacts',
            label: _('Contacts'),
          },
        ],
      },
      {
        label: _('Create'),
        items: [
          {
            link: '/contacts/create',
            icon: 'library_add',
            label: _('Create contact'),
          },
        ],
      },
      {
        label: _('Tools'),
        items: [
          {
            link: '/communication',
            icon: 'contact_phone',
            label: _('Communication'),
          },

          {
            link: '/task-manager',
            icon: 'add_task',
            label: _('Task manager'),
          },

          {
            link: '/notes',
            icon: 'edit_note',
            label: _('Notes'),
          },

          {
            link: '/calendar',
            icon: 'calendar_month',
            label: _('Calendar'),
          },
          {
            link: '/drive',
            icon: 'cloud_upload',
            label: _('Drive'),
          },
          {
            link: '/email-manager',
            icon: 'alternate_email',
            label: _('Emails'),
          },
        ],
      },
      {
        label: _('Add'),
        items: [
          {
            link: '/task-manager/task-create',
            icon: 'library_add',
            label: _('Add task'),
          },
          {
            link: '/email-manager/create-email',
            icon: 'library_add',
            label: _('Create a new email message'),
          },
          {
            link: '/notes/create-text-note',
            icon: 'library_add',
            label: _('Text note'),
          },
          {
            link: '/notes/create-audio-note',
            icon: 'library_add',
            label: _('Audio note'),
          },
          {
            link: '/notes/create-video-note',
            icon: 'library_add',
            label: _('Video note'),
          },
          {
            link: '/notes/create-file-upload',
            icon: 'library_add',
            label: _('File upload'),
          },
        ],
      },
      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  partnerOfficeMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Partner office'),
        items: [
          {
            link: '/partner-office',
            icon: 'dashboard',
            label: _('Dashboard'),
          },
          {
            link: '/partner-office/clients',
            icon: 'group',
            label: _('Clients'),
          },
          {
            link: '/partner-office/clients-transactions',
            icon: 'sync_alt',
            label: _('Clients transactions'),
          },
          {
            link: '/partner-office/tasklist',
            icon: 'checklist',
            label: _('Tasks'),
          },
          {
            link: '/partner-office/codes',
            icon: 'qr_code',
            label: _('My tracking codes'),
          },
        ],
      },

      {
        label: _('Verified partner program'),
        items: [
          {
            link: '/partner-office/verified',
            icon: 'dashboard',
            label: _('Dashboard'),
          },
        ],
      },

      {
        label: _('Strategic partnership'),
        items: [
          {
            link: '/partner-office/strategy',
            icon: 'dashboard',
            label: _('Dashboard'),
          },
        ],
      },
      {
        label: _('Help'),
        items: [
          {
            link: '/partner-office-info',
            icon: 'meeting_room',
            label: _('Partner office'),
          },
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  procurementsMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Options'),
        items: [
          {
            link: '/shopping-cart',
            icon: 'shopping_cart',
            label: _('Shopping cart'),
          },
          {
            link: '/procurements',
            icon: 'shopping_bag',
            label: _('Procurements'),
          },
          {
            link: '/procurement-auctions',
            icon: 'gavel',
            label: _('Procurement auctions'),
          },
        ],
      },

      {
        label: _('Procurement ratings'),
        items: [
          {
            link: '/procurement-ratings',
            icon: 'star',
            label: _('Received ratings'),
          },
          {
            link: '/procurement-ratings/given-ratings',
            icon: 'star_border',
            label: _('Given ratings'),
          },
          {
            link: '/procurement-ratings/pending-ratings',
            icon: 'star_half',
            label: _('Pending ratings'),
          },
        ],
      },

      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  employeeCalendarMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Application'),
        items: [
          {
            link: '/calendar',
            icon: 'calendar_month',
            label: _('Calendar'),
          },
        ],
      },
      {
        label: _('Create'),
        items: [
          {
            link: '/calendar/create-meeting',
            icon: 'library_add',
            label: _('Create meeting'),
          },
          {
            link: '/calendar/create-new-calendar',
            icon: 'library_add',
            label: _('Create new calendar'),
          },
        ],
      },
      {
        label: _('Productivity tools'),
        items: [
          {
            link: '/communication',
            icon: 'contact_phone',
            label: _('Communication'),
          },

          {
            link: '/task-manager',
            icon: 'add_task',
            label: _('Task manager'),
          },

          {
            link: '/notes',
            icon: 'edit_note',
            label: _('Notes'),
          },

          {
            link: '/contacts',
            icon: 'contacts',
            label: _('Contacts'),
          },
          {
            link: '/drive',
            icon: 'cloud_upload',
            label: _('Drive'),
          },
          {
            link: '/email-manager',
            icon: 'alternate_email',
            label: _('Emails'),
          },
        ],
      },
      {
        label: _('Add'),
        items: [
          {
            link: '/task-manager/task-create',
            icon: 'library_add',
            label: _('Add task'),
          },
          {
            link: '/email-manager/create-email',
            icon: 'library_add',
            label: _('Create a new email message'),
          },
          {
            link: '/notes/create-text-note',
            icon: 'library_add',
            label: _('Text note'),
          },
          {
            link: '/notes/create-audio-note',
            icon: 'library_add',
            label: _('Audio note'),
          },
          {
            link: '/notes/create-video-note',
            icon: 'library_add',
            label: _('Video note'),
          },
          {
            link: '/notes/create-file-upload',
            icon: 'library_add',
            label: _('File upload'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  erpCompanyNavigatorMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Company'),
        items: [
          {
            link: '/co-workers',
            icon: 'badge',
            label: _('Co-workers'),
          },

          {
            link: '/org-chart',
            icon: 'account_tree',
            label: _('Org chart'),
          },
          {
            link: '/company-stream',
            icon: 'speaker_notes',
            label: _('Company stream'),
          },
          {
            link: '/worktime',
            icon: 'work_history',
            label: _('Worktime manager'),
          },
          {
            link: '/communication',
            icon: 'contact_phone',
            label: _('Communication'),
          },
          {
            link: '/notifications',
            icon: 'notifications_active',
            label: _('Notifications'),
          },
          {
            link: '/drive',
            icon: 'cloud',
            label: _('Business Drive'),
          },
          {
            link: '/contacts',
            icon: 'contacts',
            label: _('Contacts'),
          },
          {
            link: '/notes',
            icon: 'edit_note',
            label: _('Notes'),
          },
          {
            link: '/calendar',
            icon: 'calendar_month',
            label: _('Calendar'),
          },
          {
            link: '/business-management',
            icon: 'tune',
            label: _('Settings'),
          },
        ],
      },
      {
        label: _('Modules'),
        items: [
          {
            link: '/crm',
            icon: 'support_agent',
            label: _('CRM'),
          },

          {
            link: '/sales-team',
            icon: 'supervisor_account',
            label: _('Sales'),
          },
          {
            link: '/target-market-planner',
            icon: 'travel_explore',
            label: _('Target Market'),
          },
          {
            link: '/website-application-manager',
            icon: 'app_shortcut',
            label: _('Website'),
          },
          {
            link: '/social-connections',
            icon: 'groups',
            label: _('Social'),
          },
          {
            link: '/popularity-center',
            icon: 'insights',
            label: _('Popularity Center'),
          },
          {
            link: '/marketing-tools',
            icon: 'online_prediction',
            label: _('Marketing'),
          },
          {
            link: '/professional-services',
            icon: 'construction',
            label: _('Professional Services'),
          },
          {
            link: '/hrms',
            icon: 'supervisor_account',
            label: _('Human Resource'),
          },
          {
            link: '/location-management',
            icon: 'location_city',
            label: _('Locations'),
          },
          {
            link: '/bi',
            icon: 'query_stats',
            label: _('BI Reports'),
          },
          {
            link: '/tax-management',
            icon: 'receipt_long',
            label: _('Tax'),
          },
          {
            link: '/transportation-management',
            icon: 'local_shipping',
            label: _('Transportation'),
          },
          {
            link: '/insurance-management',
            icon: 'broken_image',
            label: _('Insurance'),
          },
          {
            link: '/payment-management',
            icon: 'payments',
            label: _('Payments'),
          },
          {
            link: '/bank-account-management',
            icon: 'account_balance',
            label: _('Bank Account Management'),
          },
          {
            link: '/auction-management',
            icon: 'gavel',
            label: _('Auctions'),
          },
          {
            link: '/partner-office',
            icon: 'dashboard',
            label: _('Partner Office'),
          },
          {
            link: '/rbac',
            icon: 'security',
            label: _('Roles'),
          },
          {
            link: '/task-manager',
            icon: 'add_task',
            label: _('Task manager'),
          },
          {
            link: '/email-manager',
            icon: 'alternate_email',
            label: _('Email manager'),
          },
          {
            link: '/physical-products',
            icon: 'pallet',
            label: _('Physical products'),
          },
          {
            link: '/digital-products',
            icon: 'cloud_download',
            label: _('Digital products'),
          },
          {
            link: '/renting-products',
            icon: 'date_range',
            label: _('Rentable products'),
          },
          {
            link: '/procurement',
            icon: 'handshake',
            label: _('Procurement'),
          },
        ],
      },
      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
          {
            commandname: 'business_networking',
            icon: 'group_add',
            label: _('Business networking'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  businessTaskManagerMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Application'),
        items: [
          {
            link: '/task-manager',
            icon: 'add_task',
            label: _('Task manager'),
          },
          {
            link: '/task-manager/tasks',
            icon: 'checklist',
            label: _('Tasks'),
          },
          {
            link: '/task-manager/workgroups-projects',
            icon: 'topic',
            label: _('Workgroups / Projects'),
          },
          {
            link: '/task-manager/task-pipelines',
            icon: 'route',
            label: _('Task pipelines'),
          },
        ],
      },
      {
        label: _('Create'),
        items: [
          {
            link: '/task-manager/task-create',
            icon: 'library_add',
            label: _('Add task'),
          },
          {
            link: '/task-manager/workgroup-project-create',
            icon: 'library_add',
            label: _('Create workgroup / project'),
          },
          {
            link: '/task-manager/create-task-pipeline',
            icon: 'library_add',
            label: _('Create new task pipeline'),
          },
        ],
      },
      {
        label: _('Tools'),
        items: [
          {
            link: '/communication',
            icon: 'contact_phone',
            label: _('Communication'),
          },

          {
            link: '/calendar',
            icon: 'calendar_month',
            label: _('Calendar'),
          },
          {
            link: '/notes',
            icon: 'edit_note',
            label: _('Notes'),
          },

          {
            link: '/contacts',
            icon: 'contacts',
            label: _('Contacts'),
          },
          {
            link: '/drive',
            icon: 'cloud_upload',
            label: _('Drive'),
          },
          {
            link: '/email',
            icon: 'alternate_email',
            label: _('Emails'),
          },
        ],
      },
      {
        label: _('Add'),
        items: [
          {
            link: '/calendar/create-meeting',
            icon: 'library_add',
            label: _('Create meeting'),
          },
          {
            link: '/email-manager/create-email',
            icon: 'library_add',
            label: _('Create a new email message'),
          },
          {
            link: '/notes/create-text-note',
            icon: 'library_add',
            label: _('Text note'),
          },
          {
            link: '/notes/create-audio-note',
            icon: 'library_add',
            label: _('Audio note'),
          },
          {
            link: '/notes/create-video-note',
            icon: 'library_add',
            label: _('Video note'),
          },
          {
            link: '/notes/create-file-upload',
            icon: 'library_add',
            label: _('File upload'),
          },
        ],
      },
      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  erpProfessionalServicesMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Automations'),
        items: [
          {
            link: '/professional-services/sales-workflows',
            icon: 'account_tree',
            label: _('Sales workflows'),
          },
          {
            link: '/professional-services/sales-workflow/create',
            icon: 'library_add',
            label: _('Create a sales workflow'),
          },
        ],
      },

      {
        label: _('Options'),
        items: [
          {
            link: '/professional-services/calendars',
            icon: 'event',
            label: _('Calendars'),
          },
        ],
      },

      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  erpFinancialManagementMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Modules'),
        items: [
          {
            link: '/business-wallet',
            icon: 'account_balance_wallet',
            label: _('Business wallet'),
            visible: this.isMenuAccess('business_wallet'),
          },
          {
            link: '/bank-account-management/bank-accounts',
            icon: 'account_balance',
            label: _('Bank account management'),
            visible: this.isMenuAccess('bank_accounts_manage'),
          },
          {
            link: '/payment-providers',
            icon: 'compare',
            label: _('Connected payment providers'),
            visible: this.isMenuAccess('payment_provider'),
          },
          {
            link: '/payment-on-spot',
            icon: 'storefont',
            label: _('Payment on the spot'),
            visible: this.isMenuAccess('payment_spot'),
          },
        ],
      },
      {
        label: _('Money management'),
        visible: this.isMenuAccess('business_wallet'),
        items: [
          {
            link: '/business-wallet/balance-upload',
            icon: 'trending_up',
            label: _('Balance upload'),
            visible: this.isMenuAccess('business_wallet'),
          },
          {
            link: '/business-wallet/currency-exchange',
            icon: 'currency_exchange',
            label: _('Currency exchange'),
            visible: this.isMenuAccess('business_wallet'),
          },
        ],
      },
      {
        label: _('Create'),
        items: [
          {
            link: '/bank-account-management/add-bank-account',
            icon: 'library_add',
            label: _('Add new bank account'),
            visible: this.isMenuAccess('bank_accounts_manage'),
          },
          {
            link: '/business-wallet/create',
            icon: 'library_add',
            label: _('Create wallet sub-account'),
            visible: this.isMenuAccess('business_wallet'),
          },
          {
            link: '/payment-providers/connect-payment-provider',
            icon: 'library_add',
            label: _('Connect your payment provider'),
            visible: this.isMenuAccess('payment_provider'),
          },
          {
            link: '/payment-on-spot/add-payment-on-spot',
            icon: 'library_add',
            label: _('Add a new on-site payment method'),
            visible: this.isMenuAccess('payment_spot'),
          },
        ],
      },
      {
        label: this.translateService.instant('Settings'),
        visible: this.isMenuAccess('bank_accounts_manage') || this.isMenuAccess('payment_spot'),
        items: [
          {
            link: '/bank-account-management/settings-added-banks',
            icon: 'dns',
            label: _('Banks added to database'),
            visible: this.isMenuAccess('bank_accounts_manage'),
          },
          {
            link: '/bank-account-management/settings-add-bank-to-database',
            icon: 'library_add',
            label: _('Add bank to our system'),
            visible: this.isMenuAccess('bank_accounts_manage'),
          },
          {
            link: '/payment-on-spot/settings-payment-on-spots',
            icon: 'dns',
            label: _('Payment method added to database'),
            visible: this.isMenuAccess('payment_spot'),
          },
          {
            link: '/payment-on-spot/settings-add-payment-on-spot-to-database',
            icon: 'library_add',
            label: _('Add a new on-site payment method to our system'),
            visible: this.isMenuAccess('payment_spot'),
          },
        ],
      },

      {
        label: this.translateService.instant('Databases'),
        visible:
          this.isMenuAccess('bank_accounts_manage') ||
          this.isMenuAccess('payment_spot') ||
          this.isMenuAccess('payment_provider'),
        items: [
          {
            link: '/bank-account-management/system-banks-database',
            icon: 'folder_copy',
            label: _('Banks'),
            visible: this.isMenuAccess('bank_accounts_manage'),
          },
          {
            link: '/payment-providers/system-payment-providers-database',
            icon: 'folder_copy',
            label: _('Database of payment providers'),
            visible: this.isMenuAccess('payment_provider'),
          },
          {
            link: '/payment-on-spot/system-payment-on-spots-database',
            icon: 'folder_copy',
            label: _('Payment options on the spot'),
            visible: this.isMenuAccess('payment_spot'),
          },
        ],
      },

      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  erpCrmMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: this.translateService.instant('Modules'),
        visible:
          this.isMenuAccess('prospect_read') ||
          this.isMenuAccess('deals_read') ||
          this.isMenuAccess('offers_read') ||
          this.isMenuAccess('leads_read'),
        items: [
          {
            link: '/crm/contacts',
            icon: 'group_add',
            label: _('Contacts'),
            visible: this.isMenuAccess('prospect_read'),
          },
          {
            link: '/crm/deals',
            icon: 'handshake',
            label: _('Deals'),
            visible: this.isMenuAccess('deals_read'),
          },

          {
            link: '/crm/offers',
            icon: 'percent',
            label: _('Offers'),
            visible: this.isMenuAccess('offers_read'),
          },
          {
            link: '/crm/sales-leads',
            icon: 'transcribe',
            label: _('Sales leads'),
            visible: this.isMenuAccess('leads_read'),
          },
        ],
      },
      {
        label: this.translateService.instant('Create'),
        visible:
          this.isMenuAccess('deals_create') ||
          this.isMenuAccess('prospect_create') ||
          this.isMenuAccess('offers_create') ||
          this.isMenuAccess('leads_create'),
        items: [
          {
            link: '/crm/create-deal',
            icon: 'library_add',
            label: _('Create deal'),
            visible: this.isMenuAccess('deals_create'),
          },
          {
            link: '/crm/create-contact',
            icon: 'library_add',
            label: _('Create contact'),
            visible: this.isMenuAccess('prospect_create'),
          },
          {
            link: '/crm/create-offer',
            icon: 'library_add',
            label: _('Create offer'),
            visible: this.isMenuAccess('offers_create'),
          },
          {
            link: '/crm/create-sales-lead',
            icon: 'library_add',
            label: _('Create sales lead'),
            visible: this.isMenuAccess('leads_create'),
          },
        ],
      },
      {
        label: this.translateService.instant('Tools'),
        visible: this.isMenuAccess('add_member_to_contacts'),
        items: [
          {
            link: '/crm/browse-member-to-contact',
            icon: 'group_add',
            label: _('Add member to contacts'),
            visible: this.isMenuAccess('add_member_to_contacts'),
          },
        ],
      },
      {
        label: this.translateService.instant('Pipelines'),
        visible:
          this.isMenuAccess('deal_pipelines') ||
          this.isMenuAccess('crm_contact_pipelines') ||
          this.isMenuAccess('offer_pipelines') ||
          this.isMenuAccess('lead_pipelines'),
        items: [
          {
            link: '/crm/deal-pipelines',
            icon: 'route',
            label: _('Deal pipelines'),
            visible: this.isMenuAccess('deal_pipelines'),
          },

          {
            link: '/crm/contacts-pipelines',
            icon: 'route',
            label: _('Contacts pipelines'),
            visible: this.isMenuAccess('crm_contact_pipelines'),
          },

          {
            link: '/crm/offer-pipelines',
            icon: 'route',
            label: _('Offer pipelines'),
            visible: this.isMenuAccess('offer_pipelines'),
          },

          {
            link: '/crm/sales-lead-pipelines',
            icon: 'route',
            label: _('Sales lead pipelines'),
            visible: this.isMenuAccess('lead_pipelines'),
          },
        ],
      },
      {
        label: this.translateService.instant('Settings'),
        visible: this.isMenuAccess('crm_settings'),
        items: [
          {
            link: '/custom-fields',
            icon: 'assignment',
            label: _('Custom fields'),
            visible: this.isMenuAccess('crm_settings'),
          },
          {
            link: '/crm/legal-entity-type-settings',
            icon: 'card_membership',
            label: _('Types of legal entity'),
            visible: this.isMenuAccess('crm_settings'),
          },
        ],
      },
      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
          {
            commandname: 'business_networking',
            icon: 'group_add',
            label: _('Business networking'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  erpRBACMenu(activepage: any) {
    this.moduleEnumList = this.rbacHelperService.getModuleEnums();

    this.moduleMenuItems = [
      {
        label: _('Rules'),
        items: [
          {
            link: '/rbac',
            icon: 'security',
            label: _('Access rules'),
          },
          {
            link: '/rbac/create-rbac-group',
            icon: 'post_add',
            label: _('Create access rule'),
          },
          {
            link: '/rbac/employees-access',
            icon: 'admin_panel_settings',
            label: _('Employees access'),
          },
          {
            link: '/rbac/create-employees-access',
            icon: 'post_add',
            label: _('Assign an access rule to an employee'),
          },
        ],
      },
      {
        label: _('Module access rules'),
        items: this.moduleEnumList
          ? [
              ...this.moduleEnumList.map((moduleItem: any) => {
                return {
                  icon: moduleItem.moduleIcon,
                  label: this.rbacHelperService.getRuleTypeModulename(moduleItem.moduleEnum),
                  link:
                    '/rbac/rule-module/' +
                    this.rbacHelperService.getRuleTypeLink(moduleItem.moduleEnum),
                };
              }),
            ]
          : [],
      },

      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    if (this.rule_type) {
      this.module_active = activepage + this.rule_type;
    } else {
      this.module_active = activepage;
    }
  }

  isMenuAccess(accessType: any) {
    let state: boolean = false;

    this.store$
      .select(isRbacListContainsRbacRule(accessType))
      .pipe(take(1))
      .subscribe((res) => {
        state = res;
      });

    return state;
  }
  erpEmailManagerMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Emails'),
        items: [
          {
            link: '/email-manager',
            icon: 'mail',
            label: _('Inbox'),
          },
          {
            link: '/email-manager/folder/sent',
            icon: 'markunread_mailbox',
            label: _('Sent'),
          },
          {
            link: '/email-manager/folder/drafts',
            icon: 'design_services',
            label: _('Drafts'),
          },
          {
            link: '/email-manager/folder/trash',
            icon: 'delete',
            label: _('Trash'),
          },
        ],
      },
      {
        label: _('Create'),
        items: [
          {
            link: '/email-manager/create-email',
            icon: 'library_add',
            label: _('Create a new email message'),
          },
          {
            link: '/bank-account-management/add-bank-account',
            icon: 'library_add',
            label: _('New contact card'),
          },
        ],
      },
      {
        label: _('Contacts'),
        items: [
          {
            link: '/contacts',
            icon: 'contacts',
            label: _('Personal contacts'),
          },
          {
            link: '/co-workers',
            icon: 'badge',
            label: _('Co-workers'),
          },
          {
            link: '/crm/contacts',
            icon: 'support_agent',
            label: _('CRM Contacts'),
          },
        ],
      },
      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  erpPopularityCenterMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Modules'),
        items: [
          /*
          {
            link: '/popularity-center',
            icon: 'dashboard',
            label: 'Dashboard',
          },
          {
            link: '/popularity-center/stories',
            icon: 'video_chat',
            label: 'Stories',
          },*/
          {
            link: '/activity-stream-posts',
            icon: 'rate_review',
            label: _('Activity stream posts'),
          },
          {
            link: '/community-stream-posts',
            icon: 'forum',
            label: _('Community stream posts'),
          },
          {
            link: '/media-gallery',
            icon: 'web_stories',
            label: _('Media gallery'),
          },
          /*
          {
            link: '/popularity-center/omnichannel',
            icon: 'dynamic_feed',
            label: _('Omnichannel'),
          },
          {
            link: '/popularity-center/settings',
            icon: 'tune',
            label: _('Settings'),
          },*/
        ],
      },
      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  erpSocialConnectionMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Modules'),
        items: [
          {
            link: '/social-connections/followers',
            icon: 'rss_feed',
            label: _('Followers'),
          },
          {
            link: '/social-connections/following',
            icon: 'group_add',
            label: _('Following'),
          },
        ],
      },
      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  erpHRMSMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Modules'),
        visible:
          this.isMenuAccess('employee_management') ||
          this.isMenuAccess('employee_invitation') ||
          this.isMenuAccess('employee_recruitment'),
        items: [
          {
            label: _('Employee management'),
            icon: 'manage_accounts',
            link: '/hrms/employee-management',
            visible: this.isMenuAccess('employee_management'),
          },
          {
            label: _('Employee invitations'),
            icon: 'person_add',
            link: '/hrms/employee-invitations',
            visible: this.isMenuAccess('employee_invitation'),
          },
          {
            label: _('Recruitment management'),
            icon: 'handshake',
            link: '/hrms/recruitment-management',
            visible: this.isMenuAccess('employee_recruitment'),
          },
        ],
      },

      {
        label: _('Pipelines'),
        visible:
          this.isMenuAccess('employee_pipelines') ||
          this.isMenuAccess('recruitment_pipelines') ||
          this.isMenuAccess('invitation_pipelines'),
        items: [
          {
            label: _('Employee pipelines'),
            icon: 'route',
            link: '/hrms/employee-pipelines',
            visible: this.isMenuAccess('employee_pipelines'),
          },
          {
            label: _('Recruitment pipelines'),
            icon: 'route',
            link: '/hrms/recruitment-pipelines',
            visible: this.isMenuAccess('recruitment_pipelines'),
          },
          {
            label: _('Invitation pipelines'),
            icon: 'route',
            link: '/hrms/invitation-pipelines',
            visible: this.isMenuAccess('invitation_pipelines'),
          },
        ],
      },
      {
        label: _('Settings'),
        visible: this.isMenuAccess('employee_settings'),
        items: [
          {
            label: _('Shared and employee email account settings'),
            icon: 'folder_shared',
            link: '/hrms/email-account-settings',
            visible: this.isMenuAccess('employee_settings'),
          },
          {
            label: _('Job titles'),
            icon: 'badge',
            link: '/hrms/settings-job-titles',
            visible: this.isMenuAccess('employee_settings'),
          },
          {
            label: _('Skills'),
            icon: 'card_membership',
            link: '/hrms/settings-skills',
            visible: this.isMenuAccess('employee_settings'),
          },
        ],
      },
      {
        label: _('Databases'),
        visible: this.isMenuAccess('employee_settings'),
        items: [
          {
            label: _('Job titles'),
            icon: 'badge',
            link: '/hrms/job-titles',
            visible: this.isMenuAccess('employee_settings'),
          },
          {
            label: _('Skills'),
            icon: 'card_membership',
            link: '/hrms/skills',
            visible: this.isMenuAccess('employee_settings'),
          },
        ],
      },
      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
          {
            commandname: 'business_networking',
            icon: 'group_add',
            label: _('Business networking'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  erpMarketingToolsMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Modules'),
        items: [
          {
            link: '/marketing-tools',
            icon: 'dashboard',
            label: _('Dashboard'),
          },
          {
            link: '/discount-offers',
            icon: 'sell',
            label: _('Discount offers'),
          },
          {
            link: '/reputation-manager',
            icon: 'star',
            label: _('Reputation manager'),
          },
          {
            link: '/marketing-promotion',
            icon: 'fluorescent',
            label: _('Marketing promotion'),
          },
        ],
      },
      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  transportationManagerMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Transportation management'),
        items: [
          {
            link: '/transportation-management/shipping-rules',
            icon: 'dashboard',
            label: _('Shipping rules'),
          },
        ],
      },
      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  insuranceManagerMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Insurance management'),
        items: [
          {
            link: '/insurance-management/insurance-rules',
            icon: 'dashboard',
            label: _('Insurance rules'),
          },
        ],
      },
      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  auctionManagerMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Auction management'),
        visible: this.isMenuAccess('auction_manage'),
        items: [
          {
            link: '/auction-management',
            icon: 'dashboard',
            label: 'Dashboard',
            visible: this.isMenuAccess('auction_manage'),
          },
          {
            link: '/auction-management/bid-increments',
            icon: 'content_copy',
            label: 'Bid increments',
            visible: this.isMenuAccess('auction_manage'),
          },
        ],
      },
      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  locationManagerMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Location management'),
        visible:
          this.isMenuAccess('location_manage') ||
          this.isMenuAccess('location_service_area') ||
          this.isMenuAccess('location_meeting_rooms'),
        items: [
          {
            link: '/location-management',
            icon: 'dashboard',
            label: _('Dashboard'),
            visible:
              this.isMenuAccess('location_manage') ||
              this.isMenuAccess('location_service_area') ||
              this.isMenuAccess('location_meeting_rooms'),
          },
          {
            link: '/location-management/locations',
            icon: 'location_on',
            label: _('Locations'),
            visible: this.isMenuAccess('location_manage'),
          },
          {
            link: '/location-management/service-areas',
            icon: 'map',
            label: _('Service areas'),
            visible: this.isMenuAccess('location_service_area'),
          },
          {
            link: '/location-management/meeting-rooms',
            icon: 'meeting_room',
            label: _('Meeting rooms'),
            visible: this.isMenuAccess('location_meeting_rooms'),
          },
        ],
      },
      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  customFieldsMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Modules'),
        items: [
          {
            link: '/custom-fields',
            icon: 'dashboard',
            label: _('Custom fields'),
          },
          {
            link: '/form-builder',
            icon: 'dashboard',
            label: _('Form builder'),
          },
        ],
      },

      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }
  formBuilderMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Modules'),
        items: [
          {
            link: '/form-builder',
            icon: 'dashboard',
            label: _('Form builder'),
          },
          {
            link: '/custom-fields',
            icon: 'dashboard',
            label: _('Custom fields'),
          },
        ],
      },

      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  erpTargetMarketMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Options'),
        items: [
          {
            link: '/target-market-planner/target-markets',
            icon: 'travel_explore',
            label: _('Target markets'),
          },
        ],
      },

      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  businessPassportMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Public profile'),
        items: [
          {
            link: '/business-profile/' + this.selectedBusiness?.business_mention_name,
            icon: 'apps',
            label: _('Profile'),
            open_side: 'core',
          },
          {
            link: '/business-management',
            icon: 'assignment_ind',
            label: _('Profile settings'),
            open_side: 'erp',
          },
        ],
      },
      {
        label: _('Settings / Helpers'),
        items: [
          {
            link: '/subscription-status',
            icon: 'card_membership',
            label: _('Subscription status'),
            visible: this.isMenuAccess('subscription_settings'),
            open_side: 'erp',
          },
          {
            link: '/traditional-bank-transfer',
            icon: 'clear_all',
            label: _('Traditional bank transfer'),
            open_side: 'erp',
          },
          {
            link: '/invoices',
            icon: 'receipt_long',
            label: _('Invoices'),
            open_side: 'erp',
            visible: this.isMenuAccess('subscription_settings'),
          },
          {
            link: '/premium-subscription',
            icon: 'local_police',
            label: _('Premium membership'),
            open_side: 'erp',
            visible: this.isMenuAccess('subscription_settings'),
          },
          {
            link: '/premium-subscription/add-ons',
            icon: 'local_police',
            label: _('Add ons'),
            open_side: 'erp',
            visible: this.isMenuAccess('subscription_settings'),
          },
          {
            link: '/business-management/verification',
            icon: 'how_to_reg',
            label: _('Verification'),
            open_side: 'erp',
            visible: this.isMenuAccess('business_management'),
          },
          {
            link: '/org-chart-settings',
            icon: 'account_tree',
            label: _('Org chart settings'),
            open_side: 'erp',
          },
          {
            link: '/custom-fields',
            icon: 'assignment',
            label: _('Custom fields'),
            open_side: 'erp',
            visible: this.isMenuAccess('helper_settings'),
          },
        ],
      },

      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'settings_accessibility',
            label: _('Hire us'),
            open_side: 'erp',
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  salesTeamMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Sales team'),
        items: [
          {
            link: '/sales-team',
            icon: 'reduce_capacity',
            label: _('Dashboard'),
          },
          {
            link: '/sales-team/structure',
            icon: 'account_tree',
            label: _('Structure of sales teams'),
          },
          {
            link: '/sales-team/team-members',
            icon: 'bubble_chart',
            label: _('Sales team'),
          },
          {
            link: '/sales-team/sales-plan',
            icon: 'query_stats',
            label: _('Sales plan'),
          },
          {
            link: '/sales-team/sales-channels',
            icon: 'polyline',
            label: _('Sales channels'),
          },
          {
            link: '/sales-team/manage-team',
            icon: 'sensor_occupied',
            label: _('Sales team management'),
          },
        ],
      },

      {
        label: _('Settings'),
        items: [
          {
            link: '/sales-team/add-member-sales-unit',
            icon: 'group_add',
            label: _('Add member to sales unit'),
          },
          {
            link: '/sales-team/structure-settings',
            icon: 'account_tree',
            label: _('Structure of sales teams'),
          },
        ],
      },

      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  businessManagerMenu(activepage: any) {
    this.moduleMenuItems = [
      {
        label: _('Business management'),
        visible: this.isMenuAccess('business_management'),
        items: [
          {
            link: '/business-management',
            icon: 'store',
            label: _('Settings'),
            visible: this.isMenuAccess('business_management'),
          },

          {
            link: '/business-profile/' + this.selectedBusiness?.business_mention_name,
            icon: 'apps',
            label: _('Profile'),
            open_side: 'core',
            visible: this.isMenuAccess('business_management'),
          },

          {
            link: '/business-management/delete-account',
            icon: 'exit_to_app',
            label: _('Delete account'),
            visible: this.isMenuAccess('business_management'),
          },
        ],
      },
      {
        label: _('Subscription'),
        visible: this.isMenuAccess('subscription_settings'),
        items: [
          {
            link: '/subscription-status',
            icon: 'card_membership',
            label: _('Subscription status'),
            open_side: 'erp',
            visible: this.isMenuAccess('subscription_settings'),
          },

          {
            link: '/premium-subscription',
            icon: 'local_police',
            label: _('Premium membership'),
            open_side: 'erp',
            visible: this.isMenuAccess('subscription_settings'),
          },
          {
            link: '/premium-subscription/add-ons',
            icon: 'local_police',
            label: _('Add ons'),
            open_side: 'erp',
            visible: this.isMenuAccess('subscription_settings'),
          },
          {
            link: '/invoices',
            icon: 'receipt_long',
            label: _('Invoices'),
            open_side: 'erp',
            visible: this.isMenuAccess('subscription_settings'),
          },
        ],
      },
      {
        label: _('Help'),
        items: [
          {
            link: '/hire-us',
            icon: 'work',
            label: _('Hire us'),
          },
          {
            link: '/contact-us',
            icon: 'contact_mail',
            label: _('Contact us'),
          },
        ],
      },
    ];

    this.module_active = activepage;
  }

  toggleSideBar(state = false) {
    this.store.dispatch(setLeftColumnVisible({ leftColumnVisible: state }));
  }
  closeMenu() {
    if (this.mobileView()) this.store.dispatch(setLeftColumnVisible({ leftColumnVisible: false }));
  }
}
